module.exports = __webpack_public_path__ + "img/1491378033.e7147c9a.jpg";